module.exports = __webpack_public_path__ + "img/4.7c3190c8.png";